<template>
  <v-select
    v-if="hostOptions.length"
    label="Invite hosts"
    multiple
    class="background-dark"
    :items="hostOptions"
    v-model="includedHosts"
    return-object
    item-text="name"
    item-value="identity"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @mousedown.prevent @click="toggleIncludeHosts">
        <v-list-item-action>
          <v-icon :color="includedHosts.length > 0 ? 'appMain' : ''">
            {{ toggleIcon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title> Select All </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'HostsSelect',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    hostsList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    includedHosts: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    hostOptions() {
      return this.hostsList.slice();
    },
    allSelected() {
      return this.includedHosts.length === this.hostsList.length;
    },
    someSelected() {
      return this.includedHosts.length > 0 && !this.allSelected;
    },
    toggleIcon() {
      if (this.allSelected) return 'check_box';
      if (this.someSelected) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    },
  },
  methods: {
    async toggleIncludeHosts() {
      await this.$nextTick();
      if (this.allSelected) {
        this.includedHosts = [];
      } else {
        this.selectAll();
      }
    },

    selectAll() {
      this.includedHosts = this.hostOptions;
    },
  },
};
</script>
